module.exports = "/images/about_logo_mozilla_observatory.png?db747544c2287c226cdd52fa3584e106";